/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Browser_Extension_DescriptionInputs */



/**
* | output |
* | --- |
* | "Send the decklist you're looking at on another site straight to OpenRift, and see what you own and want on a Cardmarket seller's offers." |
*
* @param {Help_Article_Browser_Extension_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_browser_extension_description = /** @type {((inputs?: Help_Article_Browser_Extension_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Browser_Extension_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schick die Deckliste, die du gerade auf einer anderen Seite ansiehst, direkt zu OpenRift und sieh bei den Angeboten eines Cardmarket-Verkäufers, was du besitzt und suchst.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyez directement à OpenRift la decklist que vous consultez sur un autre site, et voyez ce que vous possédez et recherchez dans les offres d'un vendeur Cardmarket.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("把你在其他网站上看到的卡组表直接发送到 OpenRift，并在 Cardmarket 卖家的商品中看到哪些是你已有或想要的。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("把你在其他網站上看到的牌組清單直接送到 OpenRift，並在 Cardmarket 賣家的商品上看到你已擁有與想要的卡牌。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("다른 사이트에서 보고 있는 덱 목록을 바로 OpenRift로 보내고, Cardmarket 판매자 목록에서 보유 카드와 원하는 카드를 확인하세요.")
	return /** @type {LocalizedString} */ ("Send the decklist you're looking at on another site straight to OpenRift, and see what you own and want on a Cardmarket seller's offers.")
});